import { useState } from 'react';
import { useEnsureReferralCode } from '@features/referral';
import { useReferral } from '@features/referral';
import { ReferralOverviewPanel } from '@widgets/referral/referral-overview-panel';
import { PartnersTable } from '@widgets/referral/partners-table';
import { ReferralsPageSkeleton } from '@shared/ui';

export function ReferralsPage() {
  const [page, setPage] = useState(1);
  const { isReferralBootstrapPending, isReferralDataEnabled } = useEnsureReferralCode();
  const {
    partnersCount,
    partnersBalance,
    partnersReserved,
    partnersAvailable,
    partnersAssetBalances,
    operations,
    pagination,
    isLoading,
    isOverviewLoading,
    isAccountingsLoading,
    countError,
    balanceError,
    accountingsError,
    isBalanceValidating,
    mutateOverview,
    mutateAccountings,
  } = useReferral(page, 20, { enabled: isReferralDataEnabled });

  const hasOverviewError = Boolean(countError || balanceError);
  const showInitialSkeleton =
    isReferralBootstrapPending ||
    (isReferralDataEnabled &&
      isLoading &&
      !hasOverviewError &&
      !accountingsError &&
      !operations.length);

  if (showInitialSkeleton) {
    return <ReferralsPageSkeleton />;
  }

  return (
    <div className="page-stack">
      <ReferralOverviewPanel
        balance={partnersBalance}
        reserved={partnersReserved}
        available={partnersAvailable}
        assetBalances={partnersAssetBalances}
        partnersCount={partnersCount}
        balanceError={balanceError}
        countError={countError}
        isOverviewLoading={isOverviewLoading}
        isBalanceValidating={isBalanceValidating}
        onRetryOverview={() => mutateOverview()}
      />

      <PartnersTable
        operations={operations}
        pagination={pagination}
        isLoading={isAccountingsLoading}
        error={accountingsError}
        onRefresh={() => void mutateAccountings()}
        onPageChange={setPage}
      />
    </div>
  );
}
